import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleCircle = styled.div<{ width?: string | number }>`
  width: ${(props: any) =>
    props.width
      ? typeof props.width === 'string'
        ? props.width
        : `${props.width}px`
      : '100px'};
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background: #d9d9d9;
`

export const StyleBookingId = styled.div`
  border: 1px solid ${theme.colors.borderColor};
  border-radius: 12px;
  padding: 8px;
  color: ${theme.colors.primary};
`

export const StylePersonalInfoWrapper = styled.div`
  border: 1px solid ${theme.colors.borderColor};
  border-radius: 12px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 10px;
`

export const StyleOtherInfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  & > :nth-of-type(even) {
    background-color: ${theme.colors.primaryLight};
  }
`
export const StyleOtherInfoCard = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding: 8px;
  align-items: center;
`

export const StyleDivider = styled.div`
  width: 100%;
  height: 1px;
  background: ${theme.colors.borderColor};
`

export const StylePassengerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 22px;
  column-gap: 100px;
  width: 100%;
  place-items: center;

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StylePassengerWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`
